import FeatureGates from '@atlaskit/feature-gate-js-client';

export type StatsigGateKey =
  | 'migrate_media_token_to_user_preferences_service'
  | 'migrate_cloud_user_to_agg_user_query'
  | 'manage_ui_should_disable_refetch_on_window_focus';

export const checkFeatureGate = (key: StatsigGateKey) => {
  return FeatureGates.initializeCompleted() && FeatureGates.checkGate(key);
};
